import React, { useState } from 'react';

const CandidateSearchSummaryNotes = (props) => {
    const [notes, setNotes] = useState({});
    const {initNotes,onChange, onSave} = props

    React.useEffect(() => {
        setNotes(initNotes || {});
    }, [initNotes]);

    const onChangeInput = (event) => {
        console.log('onChangeProcessInput');
        notes[event.target.name] = event.target.value
        setNotes({...notes})
        if (onChange) {
            onChange(notes);
        };
    };

    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Notes</h3>
                </div>
                <div className='card-body p-0 w-100'>
                    <div className='input-group col-sm-12 m-3'>
                        <label className={'w-100'}>Lưu ý quan trọng khi tương tác</label>
                        <textarea className='form-control'
                                  value={notes.important_note || ''}
                                  name={'important_note'}
                                  onChange={event => onChangeInput(event)}/>
                    </div>
                    <div className='input-group col-sm-12 m-3'>
                        <label className={'w-100'}>General Note</label>
                        <textarea className='form-control'
                                  value={notes.general_note || ''}
                                  name={'general_note'}
                                  onChange={event => onChangeInput(event)}/>
                    </div>
                    <div className='input-group col-sm-12 m-3'>
                        <label className={'w-100'}>Brief DVTJCUV</label>
                        <input className='form-control'
                                type={'text'}
                                value={notes.brief_dvtjcuv || ''}
                                name={'brief_dvtjcuv'}
                                onChange={event => onChangeInput(event)}/>
                    </div>
                    </div>
                    </div>
            <div className='card card-default mt-3'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Cdd Summary</h3>
                </div>
                <div className='card-body p-0 w-100'>
                    <div className='input-group col-sm-12 m-3'>
                        <label className={'w-100'}>Content</label>
                        <textarea className='form-control'
                                value={notes.content || ''}
                                name={'content'}
                                onChange={onChangeInput} />
                    </div>
                    <div className='input-group col-sm-12 m-3'>
                        <label className={'w-100'}>Note</label>
                        <textarea className='form-control'
                                value={notes.note || ''}
                                name={'note'}
                                onChange={onChangeInput} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CandidateSearchSummaryNotes;